<template>
  <section id="header">
    <div v-show="loaded">
      <transition name="fade">
        <span v-show="loaded">
          <div id="langButtons">
            <b-button
              v-for="entry in languages"
              :key="entry.title"
              @click="changeLocale(entry.language)"
              class="langButton"
            >{{entry.language.toUpperCase()}}</b-button>
          </div>
          <img src="Logo Blanc.png" alt :width="'100px'" />
          <h1>{{$t("header.title")}}</h1>
        </span>
      </transition>
      <transition name="fade2">
        <p v-show="loaded" class="delay1">{{$t("header.motto")}}</p>
      </transition>
      <transition name="fade3">
        <div class="buttons delay2" v-show="loaded">
          <b-button
            variant="outline-primary"
            size="lg"
            href="https://store.piquage.com"
            target='_blank'
          >{{$t("header.order")}}</b-button>
          <b-button
            variant="outline-secondary"
            size="lg"
            href="https://atelier-sud.fr"
            target='_blank'
          >{{$t("header.more")}}</b-button>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.loaded = true;
  },
  props: {
    changeLocale: Function,
    languages: Array
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  h1 {
    font-size: 4rem;
  }
  p {
    font-size: 1.25rem;
  }
  img {
    width: 50px;
    transform: translateY(-20px);
  }
  .langButton{
    font-size : 0.75rem
  }
  .btn-lg {
    font-size: 0.75rem;
  }
  .buttons {
    margin-top: 10px;
  }
}

@media screen and (min-width: 601px) {
  h1 {
    font-size: 8rem;
  }
  p {
    font-size: 2.5rem;
  }
  img {
    width: 100px;
    transform: translateY(-40px);
  }
  .buttons {
    margin-top: 40px;
  }
}

h1 {
  display: inline;
  font-family: "Acre", Helvetica, Arial, sans-serif;
  font-weight: 600;
}

p {
  font-weight: 100;
  font-family: "Neue Montreal", Helvetica, Arial, sans-serif;
}

.langButton {
  background: transparent;
  border-color: aliceblue;
  outline: none;
  margin: 0 0 0 10px !important;
  padding: 0 5px 0 5px;
  opacity: 0.8;
}

.langButton:focus {
  outline: 0 !important;
}

.langButton:hover {
  opacity: 1;
}

.flag-icon {
  border-radius: 100%;
}

.delay1 {
  transition-delay: 2s;
}

.delay2 {
  transition-delay: 4s;
}

.btn {
  font-family: "Acre", Helvetica, Arial, sans-serif;
  font-weight: 400;
  margin: 0 20px 0 20px;
}

.btn-outline-primary {
  transition: linear 0.2s;
  color: aliceblue;
  border-color: aliceblue;
  outline: none !important;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active {
  background-color: #236890 !important;
  border-color: #236890 !important;
  outline: none !important;
}

.btn-outline-secondary:hover,
.btn-outline-secondary:focus,
.btn-outline-secondary:active {
  background-color: #3b3b3c;
  border-color: #3b3b3c;
  outline: none !important;
}

.btn-outline-secondary {
  transition: linear 0.2s;
  color: aliceblue;
  border-color: aliceblue;
  outline: none !important;
}

.btn:hover {
  box-shadow: 0 0.5em 0.5em -0.4em var(--hover);
  transform: translateY(-0.25em);
  transition: linear 0.2s;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.fade2-enter-active {
  transition: opacity 0.7s ease-in-out;
}

.fade2-enter-to {
  opacity: 1;
}

.fade2-enter {
  opacity: 0;
}

.fade3-enter-active {
  transition: opacity 1s ease-in-out;
}

.fade3-enter-to {
  opacity: 1;
}

.fade3-enter {
  opacity: 0;
}

#header {
  color: aliceblue;
  padding: 3% 0 3% 0;
  background-color: #80d0ff;
  background-image: linear-gradient(160deg, #236890 0%, #80d0ff 100%);
}

#langButtons {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}
</style>
